<app-not-found [error]="error"/>
